import { createEpicMiddleware } from 'redux-observable';

import { http } from '@parapet/common';
import jwt from '../shared/utils/jwt';
import cookie from '../shared/utils/cookie';

/** Utils injected into each epic function */
const dependencies = () => ({
  http,
  jwt,
  cookie,
  isDev: process.env.NODE_ENV === 'development',
});

export type EpicDependencies = ReturnType<typeof dependencies>;

const epicMiddleware = (cem: typeof createEpicMiddleware) =>
  cem({ dependencies: dependencies() });

export default epicMiddleware;
